import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateAnnualUBCategorisationReport } from "../../ExportIIPExcel";
import iipTitleData from '../../../../../iip.json';
import iipFieldTitleData from '../../../../../titles.json';
import messages from '../../.././../../assets/Messages.json';

const AnnualUBCategorisationReport = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [annualUBCategorisationReport, setAnnualUBCategorisationReport] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });
    const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };


    const storedLanguage = localStorage.getItem('language');



    const getAllYears = () => {
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = currentYear; year >= 2021; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    };



    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        const getYearList = () => {
            setYears(getAllYears());
        };

        const userRole = async () => {
            showLoading(true);
            try {
                const role = await validateRolesIIPHQ(decode_token);
                if (role) {
                    getYearList();
                } else {
                    alert(
                        "You are not an authorized for IIP Report."
                    );
                    navigate("/dashboard");
                }
            } catch (error) {
                console.log(error);
                showLoading(false);
            } finally {
                showLoading(false);
            }
        };

        userRole();
    }, []);


    const handleDropdownChange = (e) => {
        setYearName(e.target.value);
    };

    const fetchAnnualUBCategorisationReport = async (postData) => {
        showLoading(true);
        try {
            const response = await axios.post(`${API_URL}api/iipReports/HQreports/AnnualUBCategorisationReport`, postData, config);
            const allData = response.data.data.MajorReportDataList;

            if (allData && allData.length > 0) {
                const mappedData = allData.map(item => ({
                    IndustryCode: item.IndustryCode,
                    weight: item.weight,
                    category_type: item.category_type,
                    index_april:item.index_april,
                    index_may:item.index_may,
                    index_june:item.index_june,
                    index_july:item.index_july,
                    index_aug:item.index_aug,
                    index_sep:item.index_sep,
                    index_oct:item.index_oct,
                    index_nov:item.index_nov,
                    index_dec:item.index_dec,
                    index_jan:item.index_jan,
                    index_feb:item.index_feb,
                    index_mar:item.index_mar
                }));

                setAnnualUBCategorisationReport(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            showLoading(false);
        }
        return [];
    };


    const handleGenerateExcel = async () => {
        if (!yearName) {
            toast.error("Please select a Survey Year", messages.COLOR_RED);
            return;
        }

        const postData = { year: yearName };
        const reportData = await fetchAnnualUBCategorisationReport(postData);

        if (reportData.length > 0) {
            const excelFileName = `AnnualUBReport`;

            const excelObjectData = {
                fileName: excelFileName,
                reportType: excelFileName,
                fileType: 'xls',
                sheetName: "IIPAnnualUBReport",
                firstRowMergeCells: "A1:N1",
                firstRowExportData: 'INDUSTRIAL PRODUCTION INDEX  U.P',
                firstRowCellNumber: 15,
                secondRowMergeCells: "A2:N2",
                secondRowText: 'USED BASED CATEGORISATION (BASE YEAR 2011-12)',
                thirdRowMergeCells: "A3:N3",
                thirdRowText: `${yearName}-${parseInt(yearName) + 1}`,
        
                headerEnglishColumns: [
                   'Description', 'Weight', 'April', 'May', 'June', 'July', 'August', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'
                ],

                excelRowData: reportData.map(item => [
                    item.category_type,
                    item.weight,
                    // item[`APR-${yearName}`], 
                    // item[`MAY-${yearName}`],
                    // item[`JUN-${yearName}`],
                    // item[`JUL-${yearName}`],
                    // item[`AUG-${yearName}`],
                    // item[`SEP-${yearName}`],
                    // item[`OCT-${yearName}`],
                    // item[`NOV-${yearName}`],
                    // item[`DEC-${yearName}`],
                    // item[`JAN-${parseInt(yearName) + 1}`],
                    // item[`FEB-${parseInt(yearName) + 1}`],
                    // item[`MAR-${parseInt(yearName) + 1}`],
                    item.index_april,
                    item.index_may,
                    item.index_june,
                    item.index_july,
                    item.index_aug,
                    item.index_sep,
                    item.index_oct,
                    item.index_nov,
                    item.index_dec,
                    item.index_jan,
                    item.index_feb,
                    item.index_mar
                ]),
            };

            generateAnnualUBCategorisationReport(excelObjectData); // Call function to generate Excel
        }
    };

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.ANNUAL_UB_CATEGORIES_REPORT : iipTitleData.en.ANNUAL_UB_CATEGORIES_REPORT }} />

                           </h4>

                            <div className="row align-items-center">
                            
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                   { storedLanguage === 'hi' ? iipFieldTitleData.hi.YEAR : iipFieldTitleData.en.YEAR}</label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleDropdownChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years &&
                                            years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                    {ele}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default AnnualUBCategorisationReport